angular.module('elfium').service('companyService', ['$q', '$uibModal', 'elfiumRestService', 'elfiumUrlService', 'elfiumConvertFieldTypesFilter', 'COMPANY_FIELD_TYPES',
    function ($q, $uibModal, elfiumRestService, elfiumUrlService, elfiumConvertFieldTypesFilter, COMPANY_FIELD_TYPES) {
        var that = this;
        that.getCompanies = function ()  {
            return elfiumRestService.getCompanies().then(that._convertFieldTypes);
        };
        that.getCompany = function (companyId)  {
            return elfiumRestService.getCompany(companyId).then(that._convertFieldTypes);
        };
        that.upsertCompany = function (company) {
            if (company.id) {
                return elfiumRestService.updateCompany(company);
            } else {
                return elfiumRestService.createCompany(company);
            }
        };
        that.isZkratkaFieldValueNotUnique = function (companyId, zkratkaFieldValue) {
            var deferred = $q.defer();
            var searchParameters = {
                zkratka: zkratkaFieldValue
            };
            elfiumRestService.searchCompanies(searchParameters).then(function (companies) {
                var isZkratkaFieldValueNotUnique = false;
                for (var i = 0; i < companies.length; ++i) {
                    if (companies[i].id != companyId) {
                        isZkratkaFieldValueNotUnique = true;
                        break;
                    }
                }
                deferred.resolve(isZkratkaFieldValueNotUnique);
            }, deferred.reject);
            return deferred.promise;
        };
        that.deleteCompany = function (companyId) {
            return elfiumRestService.deleteCompany(companyId);
        };
        that._convertFieldTypes = function (companies) {
            return $q.when(elfiumConvertFieldTypesFilter(COMPANY_FIELD_TYPES, companies));
        };
        that.openCompanyDetailModal = function (companyId) {
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('company', 'companyDetailModal'),
                controller: 'companyDetailModalController',
                resolve: {
                    companyId: function () {
                        return companyId;
                    }
                }
            });
            return modalInstance.result;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/company/companyService.ts